import {
  be,
  kk,
  ru,
  uz,
} from 'date-fns/locale'

const LOCALES = {
  ru,
  kk,
  uz,
  be,
} as const

export default function getDateFnsLocaleByIso(iso: string) {
  if (iso in LOCALES) {
    return LOCALES[iso as keyof typeof LOCALES]
  }

  return ru
}
